import { render, staticRenderFns } from "./InteractiveMaterialsTabs.vue?vue&type=template&id=11d22def&scoped=true"
import script from "./InteractiveMaterialsTabs.vue?vue&type=script&lang=js"
export * from "./InteractiveMaterialsTabs.vue?vue&type=script&lang=js"
import style0 from "./InteractiveMaterialsTabs.vue?vue&type=style&index=0&id=11d22def&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d22def",
  null
  
)

export default component.exports